import React from "react"
import { Column, Container, Row } from "../../../components/Grid"
import Hero from "../../../components/Hero"
import Icon from "../../../components/Icon"
import Layout from "../../../components/Layout"
import Resource from "../../../components/Resource"
import Section from "../../../components/Section"
import SEO from "../../../components/Seo"
import SubFooterImage from "../../../images/theme/img-subfooter-caregivers.jpg"
import "../../caregivers/caregiversStyles.scss"

const Caregivers = () => {
  return (
    <Layout className="caregivers">
      <SEO title="Cuidadores" />
      {/***************  HERO ***************/}
      <Section className="hero">
        <Hero
          title="Cuidadores"
          infographic="img-hero-infographic-caregivers.png"
          body="Mediante interacciones positivas, prepare a los niños y adolescentes para tomar decisiones saludables e infórmeles sobre los riesgos del uso indebido de sustancias."
          image="img-hero-caregivers.jpg"
        />
      </Section>

      {/***************  CAREGIVER RESOURCE ***************/}
      <Section className="resource-container midgray-background caregiver-guide-section">
        {/***************  CR: Stress Management and Mental Health ***************/}
        <Column span={12}>
          <Resource
            halfLabel
            label="GUÍA PARA LOS CUIDADORES"
            image="CVS-Pharma-CareerProfile-CaregiverGuide.jpg"
            title="Manejo del estrés y salud mental"
            description={
              <p className="mt-2 mb-2">
                Esta guía para cuidadores está dirigida a madres, padres,
                tutores y otras personas a cargo de estudiantes desde preescolar
                hasta secundaria. Su propósito es ayudarles a promover
                conversaciones abiertas y brindar apoyo en temas de estrés y
                salud mental. Esta guía utiliza lenguaje adecuado a cada edad e
                incluye actividades, consejos y estrategias para facilitar
                conversaciones sobre el cuidado de la salud y el bienestar.
              </p>
            }
            actions={[
              {
                label: "Guía para los cuidadores",
                path: "/docs/CVS-Pharma-DoK-CaregiverGuide-Stress_ES.pdf",
                type: "download",
                locked: false,
              },
              // {
              //   label: "Educator Guide",
              //   path: "/docs/CVS-Pharma-DLB-Responding_to_Peer_Pressure-Pharmacists.pdf",
              //   type: "download",
              //   size: "PDF 1,000,000 GB",
              //   locked: false
              // }
            ]}
            horizontal
          />
        </Column>
        <Column span={12}>
          <Resource
            halfLabel
            label="GUÍA PARA CUIDADORES"
            image="thumbnail-caregiver-guide.jpg"
            title="Cómo entablar conversaciones esenciales con niños y adolescentes"
            description={
              <p className="mt-2 mb-2">
                Descubra formas efectivas de iniciar y mantener diálogos
                continuos con niños y adolescentes sobre el uso indebido de
                sustancias. Esta guía integral para padres y tutores ofrece
                información fundamental, ideas para actividades y sugerencias
                para iniciar conversaciones según el nivel escolar del
                estudiante.
              </p>
            }
            actions={[
              {
                label: "Guía para los cuidadores ",
                path: "/docs/CVS-Pharma-DoK-CaregiverGuide_ES.pdf",
                type: "download",
                locked: false,
              },
              // {
              //   label: "Educator Guide",
              //   path: "/docs/CVS-Pharma-DLB-Responding_to_Peer_Pressure-Pharmacists.pdf",
              //   type: "download",
              //   size: "PDF 1,000,000 GB",
              //   locked: false
              // }
            ]}
            horizontal
          />
          <Resource
            halfLabel
            label="Recursos adicionales para cuidadores"
            image="caregivers-photo-addl-resources.jpg"
            description={
              <p>
                Existe una gran variedad de recursos disponibles para ayudar a
                los cuidadores a mantener conversaciones de temas complicados
                con los jóvenes en sus vidas.
              </p>
            }
            horizontal
          >
            <Row>
              <Column span={6} className="lh-i">
                <div className="mb-1">
                  <b>Recursos comunitarios</b>
                </div>
                <ul>
                  <li style={{ marginBottom: "0.5rem" }}>
                    Farmacéuticos locales
                  </li>
                  <li style={{ marginBottom: "0.5rem" }}>Educador</li>
                  <li style={{ marginBottom: "0.5rem" }}>Consejero escolar</li>
                  <li style={{ marginBottom: "0.5rem" }}>
                    Pediatra/médico familiar
                  </li>
                  <li style={{ marginBottom: "0.5rem" }}>
                    Proveedor de servicios de salud mental
                  </li>
                  <li style={{ marginBottom: "0.5rem" }}>
                    Otros profesionales de la salud
                  </li>
                </ul>
              </Column>
              <Column span={6}>
                <div className="mb-1">
                  <b>Recursos en línea</b>
                </div>
                <div style={{ display: "flex" }}>
                  <Icon
                    className="fill-red mw-24"
                    name="rightarrow"
                    marginRight
                  />{" "}
                  <a
                    style={{ color: "#CC0000", marginBottom: "0.5rem" }}
                    href="https://www.samhsa.gov/"
                    target="_blank"
                  >
                    SAMHSA (Administración de Salud Mental y Abuso de
                    Sustancias)
                  </a>
                </div>
                <div style={{ display: "flex" }}>
                  <Icon
                    className="fill-red mw-24"
                    name="rightarrow"
                    marginRight
                  />{" "}
                  <a
                    style={{ color: "#CC0000", marginBottom: "0.5rem" }}
                    href="http://www.drugfree.org/"
                    target="_blank"
                  >
                    Partnership for Drug-Free Kids (Asociación para Niños Libres
                    de Drogas)
                  </a>
                </div>
                <div style={{ display: "flex" }}>
                  <Icon
                    className="fill-red mw-24"
                    name="rightarrow"
                    marginRight
                  />{" "}
                  <a
                    style={{ color: "#CC0000", marginBottom: "0.5rem" }}
                    href="http://teens.drugabuse.gov/"
                    target="_blank"
                  >
                    NIDA for Teens (Instituto Nacional sobre el Abuso de Drogas
                    para Adolescentes)
                  </a>
                </div>
                <div style={{ display: "flex" }}>
                  <Icon
                    className="fill-red mw-24"
                    name="rightarrow"
                    marginRight
                  />{" "}
                  <a
                    style={{ color: "#CC0000", marginBottom: "0.5rem" }}
                    href="https://www.betterwithout.it/"
                    target="_blank"
                  >
                    Better without It (Mejor sin ella)
                  </a>
                </div>
                <div style={{ display: "flex" }}>
                  <Icon
                    className="fill-red mw-24"
                    name="rightarrow"
                    marginRight
                  />{" "}
                  <a
                    style={{ color: "#CC0000" }}
                    href="https://ncsacw.acf.hhs.gov/"
                    target="_blank"
                  >
                    National Center on Substance Abuse and Child Welfare (Centro
                    Nacional sobre Abuso de Sustancias y Bienestar Infantil)
                  </a>
                </div>
              </Column>
            </Row>
          </Resource>
        </Column>
      </Section>

      {/***************  ABOVE FOOTER CALLOUT ***************/}
      <Section className="subfooter">
        <Container>
          <Row>
            <Column span={4}>
              <img
                src={SubFooterImage}
                className="subfooter-image"
                alt="Title: Facts, Info etc."
              />
            </Column>
            <Column span={8}>
              <h3>Dato:</h3>
              <p>
                Solo el 57.2 % de los adolescentes habla con sus padres sobre
                los peligros del uso indebido de sustancias.
              </p>
              <p>
                <a
                  href="https://www.samhsa.gov/data/sites/default/files/report_3380/ShortReport-3380.html#:~:text=As%20previously%20noted%2C%20the%20majority,program%20outside%20of%20school%20(Figure"
                  target="_blank"
                >
                  <em>
                    —Administración de Salud Mental y Abuso de Sustancias
                    (SAMHSA)
                  </em>
                </a>
              </p>
            </Column>
          </Row>
        </Container>
      </Section>
    </Layout>
  )
}

export default Caregivers
